import PropTypes from "prop-types";
import "./DoubleBorder.scss";

const DoubleBorder = (props: any) => {
  return (
    <div className="double-border">
      <div className="first-border">
        <div className="second-border">
          <div className="double-border-content">{props.children}</div>
        </div>
      </div>
    </div>
  );
};

DoubleBorder.propTypes = {
  children: PropTypes.node,
};

export default DoubleBorder;
